<template>
  <span id="add-storage-location" v-if="showAddStorageLocations()">
    <el-button
      id="add-storage-location-button"
      class="button-action-default add-storage-location-margin-bottom"
      size="mini"
      type="success"
      plain
      @click="dialogVisible = true"
    >{{ $t('layoutTemplate.addStorageLocation') }}</el-button>

    <el-dialog
      id="add-storage-location-dialog"
      v-on:open="handleOpen"
      :title="$t('layoutTemplate.addStorageLocation')"
      :visible.sync="dialogVisible"
      width="50%"
      class="dialog-with-cols"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item :label="$t('layoutTemplate.viewDetailsTitle')" prop="warehouse">
              <el-input class="inline-input" :value="layoutTemplateName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('layoutTemplate.area')" prop="area">
              <el-select class="inline-input" v-model="form.area" size="mini">
                <el-option
                  v-for="option in areaOptions"
                  :key="option.value"
                  :label="$t(option.label)"
                  :value="option.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('layoutTemplate.code')" prop="code">
              <el-input
                class="inline-input"
                v-model="form.code"
                v-alphanumeric-validation
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item :label="$t('layoutTemplate.shipperGroup')" prop="shipperGroupId">
              <shipper-group-select v-model="form.shipperGroupId" :includeOptionAll="true" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        id="add-storage-location-dialog-footer"
        slot="footer"
        class="dialog-footer form-vertical-item flex-reverse-direction"
      >
        <el-button
          type="primary"
          id="save-storage-location-button"
          @click="submitForm()"
          size="mini"
        >{{ $t('layoutTemplate.addStorageLocation') }}</el-button>
        <el-button
          id="refresh-storage-location-button"
          @click="resetForm()"
          size="mini"
        >{{ $t('common.clear') }}</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import ShipperGroupSelect from '@/components/ShipperGroup/ShipperGroupSelect';

export default {
  name: 'AddStorageLocation',
  components: {
    ShipperGroupSelect
  },
  props: {
    layoutTemplateId: {
      type: Number,
      required: true
    },
    layoutType: {
      type: Number,
      required: true
    },
    layoutTemplateName: {
      type: String,
      default: ''
    }
  },
  computed: {
    areaOptions() {
      return constants.LAYOUT_TEMPLATE.AREA_OPTIONS.filter(
        option => option.value > 0
      );
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        layoutTemplateId: 0,
        area: null,
        code: null,
        shipperGroupId: null
      },
      formRules: {
        area: [
          {
            required: true,
            message: this.$t('layoutTemplate.error.storageLocationAreaRequired'),
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: this.$t('layoutTemplate.error.storageLocationCodeRequired'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    handleOpen() {
      this.form.layoutTemplateId = this.layoutTemplateId;
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    async submitForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            Message.closeAll();
            const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
            this.$store
              .dispatch('storageLocation/save', this.form)
              .then((response) => {
                loading.close();
                this.$message.success(response.message);
                this.resetForm();
                this.$emit('searchStorageLocations');
                resolve(response);
              })
              .catch((error) => {
                this.$message.error(error.response.message);
                loading.close();
                resolve(error);
              });
          } else {
            resolve(new Error(this.$t('common.invalid')));
          }
        });
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.area = null;
      this.form.code = null;
    },
    showAddStorageLocations() {
      return (this.layoutType === constants.LAYOUT_TEMPLATE.LAYOUT_TYPES.TEMPLATE && this.$can(this.permissions.WAREHOUSE.EDIT_LAYOUT_TEMPLATES))
          || (this.layoutType === constants.LAYOUT_TEMPLATE.LAYOUT_TYPES.LAYOUT && this.$can(this.permissions.WAREHOUSE.EDIT_LAYOUTS));
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.add-storage-location-margin-bottom {
  margin-bottom: 10px;
}
</style>
